"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_PROGRESS_REMINDER_SERIES_VARIANT_SET = exports.IN_PROGRESS_REMINDER_VARIANT = void 0;
/**
 * Stored on email logs / template `data.reminderVariant` and as translation keys for in-progress
 * reminder copy.
 */
var IN_PROGRESS_REMINDER_VARIANT;
(function (IN_PROGRESS_REMINDER_VARIANT) {
    IN_PROGRESS_REMINDER_VARIANT["stage1"] = "stage1";
    IN_PROGRESS_REMINDER_VARIANT["stage2"] = "stage2";
    IN_PROGRESS_REMINDER_VARIANT["stage3"] = "stage3";
    IN_PROGRESS_REMINDER_VARIANT["taxDeadline"] = "taxDeadline";
})(IN_PROGRESS_REMINDER_VARIANT = exports.IN_PROGRESS_REMINDER_VARIANT || (exports.IN_PROGRESS_REMINDER_VARIANT = {}));
/**
 * Series nudges only (excludes {@link IN_PROGRESS_REMINDER_VARIANT.taxDeadline}).
 */
exports.IN_PROGRESS_REMINDER_SERIES_VARIANT_SET = new Set([
    IN_PROGRESS_REMINDER_VARIANT.stage1,
    IN_PROGRESS_REMINDER_VARIANT.stage2,
    IN_PROGRESS_REMINDER_VARIANT.stage3,
]);
//# sourceMappingURL=inProgressReminder.js.map